<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName">
      <div class="row">
        <div class="col-md-12 component-title-row">
          <h3><i class="fa fa-fw fa-user"></i> {{ _('User access') }}</h3>
        </div>
      </div>
      <form class="list-filter-row" v-on:submit.prevent="search">
        <div class="list-filter-col" style="min-height: 60px">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" type="text" v-model="email" :placeholder="_('Email')" />
              <span class="input-group-btn">
                <button type="submit" class="btn btn-success" :disabled="searching"><i :class="'fa fa-fw ' + (searching ? 'fa-spinner fa-spin' : 'fa-search')"></i></button>
              </span>
            </div>
          </div>
        </div>
      </form>
      <p v-if="searched && !searching && !results.length" class="text-muted">{{ _('No shops found for this email.') }}</p>
      <table v-if="results.length" class="table table-hover">
        <thead>
          <tr>
            <th>{{ _('Shop ID') }}</th>
            <th>{{ _('Company') }}</th>
            <th>{{ _('Status') }}</th>
            <th>{{ _('Name') }}</th>
            <th>{{ _('Level') }}</th>
            <th>{{ _('Last login') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in results" :key="row.shopid + '-' + index" class="user-access-row" v-on:click="editShop(row.shopid)">
            <td>{{ row.shopid }}</td>
            <td>{{ row.companyname }}</td>
            <td v-html="shopStatus(row)"></td>
            <td>{{ row.name }}</td>
            <td>{{ levelName(row.userlevel) }}</td>
            <td>{{ formatLastLogin(row.lastlogin) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import components from '~/lib/components'
import formatters from '~/lib/formatters'

export default {
  mixins: [components, formatters],
  computed: {
    ...mapGetters(['baseDomain'])
  },
  data () {
    return {
      email: '',
      searching: false,
      searched: false,
      results: []
    }
  },
  methods: {
    async search () {
      const email = (this.email || '').trim()
      this.email = email
      if (!email || email.indexOf('@') === -1) {
        this.showError('Enter an email address')
        return
      }
      this.searching = true
      this.searched = false
      this.results = []
      try {
        const response = await axios.get(this.baseDomain + this.shopId + '/admin/useraccess.json?apikey=' + this.apiKey, {
          params: { email }
        })
        const data = response.data
        this.results = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : [])
        this.searched = true
      } catch (e) {
        this.results = []
        this.showError(e, 'The search failed.')
      } finally {
        this.searching = false
      }
    },
    shopStatus (row) {
      return this.adminShopStatusFormatter()({
        getRow () {
          return {
            getData () {
              return row
            }
          }
        }
      })
    },
    levelName (level) {
      const names = {
        2: this._('POS user'),
        3: this._('Standard user'),
        7: this._('Administrator'),
        10: this._('System Administrator')
      }
      const value = parseInt(level, 10)
      return names[value] || level
    },
    formatLastLogin (value) {
      return this.dateAndTimeFormatter()({
        getValue () {
          return value
        }
      })
    },
    editShop (shopId) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'AdminShopDetails',
        title: this._('Shop') + ' ' + shopId,
        width: 6,
        data: {
          shopId: shopId
        }
      })
    }
  }
}
</script>

<style scoped>
.user-access-row {
  cursor: pointer;
}
</style>
